import { useLocation } from 'react-router-dom'

import { AllProductUpdatesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'

export type GetProductUpdatesProps = {
  ids?: string[]
  moduleIdentifier?: string
  slug?: string
  alreadyReleased?: boolean
  releasedToday?: boolean
  preview?: boolean
  releasedAfter?: number
  featuredIn?: string
  externalUrl?: string
}

export const useGetProductUpdates = (variables: GetProductUpdatesProps) => {
  const {
    access: { locale: accessLocale },
    canSeeProductUpdates,
  } = useCurrentSession()
  const { search } = useLocation()
  const locale = getDatoLocale(accessLocale)
  const preview = variables.preview || new URLSearchParams(search).get('preview') === 'true'

  const {
    nodes: productUpdates,
    loading,
    controls,
  } = usePaginatedQuery(AllProductUpdatesDocument, {
    variables: { ...variables, preview, locale },
    fetchPolicy: 'cache-first',
    extractConnection: (e) => e.productUpdates.updatesConnection,
    skip: !canSeeProductUpdates,
  })
  return {
    loading,
    productUpdates,
    controls,
  }
}
